<section>
	<div class="mt-3 guideline-btn">
		<button class="btn btn-outline-primary" (click)="openModal(myModal)">Guidelines</button>
	</div>
    <div class="row match-height mt-4" >
      <div class="col-lg-4 col-md-6 col-sm-12" *ngFor="let event of events_list; let i =index">
       
		<div class="card">
			<div class="card-content">
				<div class="card-img">
					<div class="content-box">
						<h4>{{event?.name}}</h4>
					</div>
				  <p class="badge bg-light-info event-type-box">{{event?.event_type[0]?.displayname}}</p>
				  <a *ngIf="event.is_digital_certificate && !isApprovedByUser(event, user_role.id) && !isParticiapteByUser(event, user_role.id)" class="btn btn-floating halfway-fab bg-warning" placement="top" ngbTooltip="participate event" (click)="participateEvent(event?._id)"><i class="ft-plus"></i></a>
				  <a *ngIf="event.is_digital_certificate && isApprovedByUser(event, user_role.id)" class="btn btn-floating halfway-fab bg-warning" placement="top" ngbTooltip="download certificate" (click)="download(event?._id)"><i class="ft-download"></i></a>
				</div>
				<div class="card-body">
					<div>
						<p >
						 	<b>Organizer :</b> <span *ngFor="let item of event?.organizeremployees; let last = last">
								{{item?.user?.name}}
								<span *ngIf="!last">,</span>
							</span>
						</p>
						<p class="mb-0"><b>Location :</b> {{event?.location}}</p>
						<p><b>Date :</b> {{event?.event_date | date:'medium'}}</p>
						<div *ngIf="isApprovedByUser(event, user_role.id)">
							<button class="btn btn-primary" (click)="openLms(event?.course[0]?._id)">Learn</button>
						</div>
					</div>
					<div class="logo-box">
						<img src="assets/logo-meander-black.png" alt="meander-logo">
					</div>
				</div>
			</div>
		</div>
		
      </div>
    </div>
    <div *ngIf="!events_list || events_list.length == 0">
      Data not found!
    </div>
  </section>
  <div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>


<!-------------- Guidelines  Popup ------------------------------------------->
<div>
    <ng-template #myModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title">Guidelines For Event Participation</h4>
        <button type="button" class="close" (click)="modal.dismiss()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
		<div>
			<h4>Digital Event Participation</h4>
		</div>
       <div>
		<span>About :</span>&nbsp;&nbsp;
		<span>A Digital Certificate confirms your participation in our events.</span>
	   </div>
	   <div class="mt-2">
			<h4>How to Obtain</h4>
			<div>
				<p>1. Fill out the "Connect to Learn" form with accurate details.</p>
				<p>2. Navigate to the Event Section.</p>
				<p>3. Click on the "+" icon.</p>
				<p>4. We will review your certificate request and approve it.</p>
				<p>5. Once approved, you can download your certificate from the Event section corresponding to the event you attended.</p>
			</div>
	   </div>
	   <div>
			<h4>Benefits</h4>
			<div>
				<p>- Enhance your resume and LinkedIn profile.</p>
				<p>- Showcase and share your dedication to learning and expertise on specific subjects.</p>
			</div>
	   </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
        </div>
    </ng-template>
  </div>